import React from 'react';
import { ImGithub, ImLinkedin, ImWhatsapp } from "react-icons/im";
import { BsDiscord } from "react-icons/bs";
import { Bounce, Fade } from 'react-reveal';
import {
  IoHomeSharp,
  IoMailOpen,
} from "react-icons/io5";


const SocialMediaConnection = () => {
  return (
    <>
      <Fade right>
        <div className="my-2">
          <p className="flex items-center text-sm">
            <IoHomeSharp className="w-4 h-4 mr-2"></IoHomeSharp>Dhaka,
            Bangladesh
          </p>
          <p className="flex items-center text-sm">
            <IoMailOpen className="w-4 h-4 mr-2"></IoMailOpen>
            git.sujon@gmail.com
          </p>
        </div>
      </Fade>
      <div className='flex items-center '>
        <Bounce right>
          <a href="https://github.com/git-sujon" target="_black" title='Github'><ImGithub className='w-8 h-8 border p-1 bg-teal-600  mr-3'></ImGithub></a>
        </Bounce>

        <Bounce bottom>
          <a href="https://www.linkedin.com/in/moniruzzaman-sujon/" target="_black" title='Linkedin'><ImLinkedin className='w-8 h-8 border p-1 bg-teal-600  mr-3'></ImLinkedin></a>
        </Bounce>

        <Bounce left>
          <a href="https://discord.com/users/1005483911675117668" target="_black" title='Discord'><BsDiscord className='w-8 h-8 border p-1 bg-teal-600  mr-3'></BsDiscord></a>
        </Bounce>
        <Bounce top>
          <a href="https://wa.me/qr/S5FV3TQ6JFDVM1" target="_black" title='WhatsApp'><ImWhatsapp className='w-8 h-8 border p-1 bg-teal-600 '></ImWhatsapp></a>
        </Bounce>
      </div>
    </>

  );
};

export default SocialMediaConnection;